var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/NxChat.tsx
import React12 from "react";
import { Box as Box12, makeStyles as makeStyles8 } from "@material-ui/core";

// src/components/message/NxChatMessage.tsx
import React3, { useState as useState2 } from "react";
import { Avatar as Avatar2, Box as Box3, useTheme as useTheme2 } from "@material-ui/core";
import { InfoOutlined } from "@playvs-inc/nexus-icons";
import {
  NxRandomAvatar,
  NxRandomAvatars
} from "@playvs-inc/nexus-random-avatars";
import {
  NxTypography as NxTypography2,
  NxUserOnlineStatus,
  parseMessage
} from "@playvs-inc/nexus-components";

// src/components/message/NxChatMessageAuthor.tsx
import React from "react";
import { Avatar, Box, useTheme } from "@material-ui/core";
import { MUIThemeModeEnum } from "@playvs-inc/nexus-theme";
import { CaptainNew, CaptainNewInvert } from "@playvs-inc/nexus-icons";
import { NxTooltip, NxTypography } from "@playvs-inc/nexus-components";

// src/Chat.helpers.tsx
import { ThemeTokens } from "@playvs-inc/nexus-theme";
var ChatRole = /* @__PURE__ */ ((ChatRole2) => {
  ChatRole2["Player"] = "player";
  ChatRole2["Coach"] = "coach";
  ChatRole2["Admin"] = "adim";
  ChatRole2["Captain"] = "captain";
  return ChatRole2;
})(ChatRole || {});
var getRoleData = ({
  isCoach,
  isAdmin,
  isCaptain
}) => {
  if (isAdmin) {
    return {
      colorToken: ThemeTokens.ColorTextWarn,
      role: "PlayVS"
    };
  }
  if (isCoach) {
    return {
      colorToken: ThemeTokens.ColorTextInfo,
      role: "Coach"
    };
  }
  if (isCaptain) {
    return {
      colorToken: ThemeTokens.ColorTextAccent,
      role: "Captain"
    };
  }
  return {
    colorToken: void 0,
    role: "Player"
  };
};
var formatTimestamp = (timestamp, options = {}) => new Intl.DateTimeFormat("en-US", __spreadValues({
  hour12: true,
  hour: "numeric",
  minute: "2-digit"
}, options)).format(new Date(timestamp));
var formatTimestampLong = (timestamp, options = {}) => new Intl.DateTimeFormat("en-US", __spreadValues({
  weekday: "long",
  month: "short",
  day: "2-digit",
  year: "numeric"
}, options)).format(new Date(timestamp));
var areTimestampsSameDay = (timestamp1, timestamp2) => {
  const options = {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit"
  };
  const intl1 = Intl.DateTimeFormat("en-US", options).format(new Date(timestamp1));
  const intl2 = Intl.DateTimeFormat("en-US", options).format(new Date(timestamp2));
  return intl2 === intl1;
};
var getPlainText = (editorState) => editorState.getCurrentContent().getPlainText("");

// src/components/message/NxChatMessage.styles.tsx
import { makeStyles } from "@material-ui/core";
var useStyles = makeStyles((theme) => ({
  avatar: {
    height: 40,
    width: 40
  },
  subAvatar: {
    height: 24,
    width: 24
  },
  author: ({ colorToken }) => {
    var _a;
    return {
      color: (_a = theme.palette[colorToken]) != null ? _a : theme.palette.ColorTextBase,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    };
  },
  authorDetails: {
    gap: theme.spacing(0.5),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center"
  },
  content: ({
    showDetails,
    isHovered,
    global
  }) => {
    const contentPadding = global ? 8.5 : 9.5;
    return {
      background: isHovered ? theme.palette.ColorBackgroundAlt : "inherit",
      padding: theme.spacing(0.5, 0.5, 0.5, showDetails ? "inherit" : contentPadding),
      width: "100%"
    };
  },
  message: ({ error }) => ({
    color: error ? theme.palette.ColorTextDisabled : theme.palette.ColorTextBase
  }),
  timestamp: {
    color: theme.palette.ColorTextAlt2
  },
  error: {
    color: theme.palette.ColorTextError
  },
  hoverTimestamp: {
    color: theme.palette.ColorTextAlt2,
    position: "absolute",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(3)
  },
  titleContainer: {
    maxWidth: "calc(100% - 100px)"
  },
  toolTip: {
    cursor: "default",
    paddingRight: theme.spacing(1)
  }
}));

// src/components/message/NxChatMessageAuthor.tsx
function NxChatMessageAuthor({
  timestamp,
  author,
  subAvatarUrl,
  isCoach = false,
  isAdmin = false,
  isCaptain = false,
  showDetails = true,
  subtitle
}) {
  const theme = useTheme();
  const { role, colorToken } = getRoleData({
    isAdmin,
    isCoach,
    isCaptain
  });
  const styles = useStyles({
    showDetails,
    colorToken
  });
  const formattedTimestamp = timestamp && formatTimestamp(timestamp);
  const formattedTimestampLong = timestamp && formatTimestampLong(timestamp);
  const captainIcon = theme.palette.type === MUIThemeModeEnum.Light ? /* @__PURE__ */ React.createElement(CaptainNew, {
    height: "16px",
    width: "16px"
  }) : /* @__PURE__ */ React.createElement(CaptainNewInvert, {
    height: "16px",
    width: "16px"
  });
  const hasAdditionalDetails = subAvatarUrl || subtitle;
  const subAvatar = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Avatar, {
    className: styles.subAvatar,
    src: subAvatarUrl
  }), " ", subtitle);
  return /* @__PURE__ */ React.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    mt: 1
  }, /* @__PURE__ */ React.createElement(Box, {
    className: styles.titleContainer,
    mb: 1
  }, /* @__PURE__ */ React.createElement(NxTypography, {
    className: styles.author,
    variant: "body2"
  }, author.name, " ", isCaptain && captainIcon), /* @__PURE__ */ React.createElement(NxTypography, {
    className: styles.authorDetails,
    variant: "body4"
  }, role, " ", hasAdditionalDetails && /* @__PURE__ */ React.createElement(React.Fragment, null, "| ", subAvatar))), /* @__PURE__ */ React.createElement(NxTooltip, {
    arrow: true,
    placement: "top",
    title: `${formattedTimestampLong} at ${formattedTimestamp}`
  }, /* @__PURE__ */ React.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end",
    pr: 1
  }, /* @__PURE__ */ React.createElement(NxTypography, {
    className: styles.timestamp,
    variant: "overline"
  }, formattedTimestamp))));
}

// src/media/NxChatImage.tsx
import React2, { useState } from "react";
import { Box as Box2, makeStyles as makeStyles2 } from "@material-ui/core";
import { clsx } from "clsx";
import { NxLightbox } from "@playvs-inc/nexus-components";
var useStyles2 = makeStyles2(() => ({
  image: {
    maxWidth: 256,
    maxHeight: 256
  },
  button: {
    background: "none",
    border: 0,
    padding: 0,
    cursor: "pointer"
  }
}));
function NxChatImage({
  media,
  className
}) {
  const styles = useStyles2();
  const { url, fileName } = media;
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(true);
  };
  return /* @__PURE__ */ React2.createElement(Box2, null, /* @__PURE__ */ React2.createElement(NxLightbox, {
    onClose: () => setIsOpen(false),
    open: isOpen,
    showTopRightClose: true,
    subtitle: "",
    title: ""
  }, /* @__PURE__ */ React2.createElement("img", {
    alt: fileName,
    src: url,
    title: fileName
  })), /* @__PURE__ */ React2.createElement("button", {
    className: styles.button,
    onClick: handleClick,
    type: "button"
  }, /* @__PURE__ */ React2.createElement("img", {
    alt: fileName,
    className: clsx(styles.image, className),
    src: url,
    title: fileName
  })));
}

// src/components/message/NxChatMessage.tsx
function NxChatMessage({
  message,
  timestamp,
  author,
  avatarUrl,
  subAvatarUrl,
  subtitle,
  isCoach = false,
  isAdmin = false,
  isCaptain = false,
  showDetails = true,
  error,
  onClickError,
  media,
  global = false,
  onlineStatus
}) {
  const theme = useTheme2();
  const [isHovered, setIsHovered] = useState2(false);
  const styles = useStyles({
    showDetails,
    error,
    isHovered,
    global
  });
  const handleHover = (val) => {
    if (!showDetails) {
      setIsHovered(val);
    }
  };
  const showBWAvatarForChatEvents = author.name === "PlayVS Message";
  const avatar = avatarUrl ? /* @__PURE__ */ React3.createElement(Avatar2, {
    alt: `${author.name}'s avatar`,
    className: styles.avatar,
    src: avatarUrl
  }) : /* @__PURE__ */ React3.createElement(NxRandomAvatar, {
    hashId: author.id,
    height: 40,
    persona: isAdmin ? "Firebob" : void 0,
    width: 40
  });
  const renderedAvatar = /* @__PURE__ */ React3.createElement(Box3, {
    mt: 0.5,
    pl: global ? 2 : 3,
    position: "relative"
  }, showBWAvatarForChatEvents ? /* @__PURE__ */ React3.createElement(NxRandomAvatars.Firebob3, {
    height: 40,
    width: 40
  }) : avatar, onlineStatus && /* @__PURE__ */ React3.createElement(NxUserOnlineStatus, {
    height: "12px",
    left: global ? 44 : 52,
    onlineStatus,
    top: 30,
    width: "12px"
  }));
  const mediaList = media && /* @__PURE__ */ React3.createElement(Box3, {
    display: "flex",
    flexWrap: "wrap",
    gridGap: "1em",
    mt: 0.5
  }, media.map((data) => /* @__PURE__ */ React3.createElement(NxChatImage, {
    key: data.sid,
    media: data
  })));
  const errorHint = /* @__PURE__ */ React3.createElement(Box3, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    mt: 0.5
  }, /* @__PURE__ */ React3.createElement(InfoOutlined, {
    color: theme.palette.ColorIconError
  }), /* @__PURE__ */ React3.createElement(NxTypography2, {
    className: styles.error,
    onClick: () => onClickError == null ? void 0 : onClickError(),
    role: onClickError ? "button" : "note",
    variant: "body5"
  }, error));
  return /* @__PURE__ */ React3.createElement(Box3, {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    gridGap: theme.spacing(1.5)
  }, showDetails && renderedAvatar, /* @__PURE__ */ React3.createElement(Box3, {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "auto",
    p: "inherit",
    position: "relative"
  }, showDetails && /* @__PURE__ */ React3.createElement(NxChatMessageAuthor, {
    author,
    isAdmin,
    isCaptain,
    isCoach,
    showDetails,
    subAvatarUrl,
    subtitle,
    timestamp
  }), /* @__PURE__ */ React3.createElement(Box3, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    width: "100%"
  }, isHovered && /* @__PURE__ */ React3.createElement(NxTypography2, {
    className: styles.hoverTimestamp,
    variant: "overline"
  }, timestamp && formatTimestamp(timestamp)), /* @__PURE__ */ React3.createElement(Box3, {
    className: styles.content,
    "data-cy": "user-messages",
    onMouseEnter: () => handleHover(true),
    onMouseLeave: () => handleHover(false)
  }, /* @__PURE__ */ React3.createElement(NxTypography2, {
    className: styles.message,
    variant: "body1"
  }, parseMessage(message)), error && errorHint, mediaList))));
}

// src/components/empty/NxChatEmptyState.tsx
import React4 from "react";
import { Box as Box4 } from "@material-ui/core";
import { LoadingSpinner, NxTypography as NxTypography3 } from "@playvs-inc/nexus-components";
import { NxSpot } from "@playvs-inc/nexus-spots-v2";

// src/components/empty/NxChatEmptyState.styles.ts
import { makeStyles as makeStyles3 } from "@material-ui/core";
var useStyles3 = makeStyles3((theme) => ({
  emptyText: {
    color: theme.palette.ColorTextDisabled
  },
  transitionWrapper: {
    transition: "opacity 0.3s linear",
    opacity: ({
      visibility
    }) => visibility === "visible" ? 1 : 0
  },
  archivedMessages: {
    textAlign: "center",
    color: theme.palette.ColorTextLink
  }
}));

// src/components/empty/NxChatEmptyState.tsx
function NxChatEmptyState({
  isLoading,
  visibility = "visible",
  stateIsClosed,
  loadingConversationState
}) {
  const styles = useStyles3({ visibility });
  return /* @__PURE__ */ React4.createElement(Box4, {
    alignItems: "center",
    className: styles.transitionWrapper,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gridGap: "0.5em",
    justifyContent: "center",
    visibility
  }, isLoading || loadingConversationState ? /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(LoadingSpinner, {
    size: "large"
  }), stateIsClosed && /* @__PURE__ */ React4.createElement(NxTypography3, {
    className: styles.archivedMessages,
    variant: "body3"
  }, "Loading Archived Messages")) : /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(NxSpot, {
    domain: "chat",
    height: 100,
    size: "large",
    variant: "secondary",
    width: 100
  }), /* @__PURE__ */ React4.createElement(NxTypography3, {
    className: styles.emptyText,
    variant: "h4"
  }, "Work out any match day details here"), /* @__PURE__ */ React4.createElement(NxTypography3, {
    className: styles.emptyText,
    variant: "body3"
  }, "Chat is available to coaches and players")));
}

// src/components/divider/NxChatMessageDivider.tsx
import React5 from "react";
import { Box as Box5, useTheme as useTheme3 } from "@material-ui/core";
import { NxTypography as NxTypography4 } from "@playvs-inc/nexus-components";

// src/components/divider/NxChatMessageDivider.styles.ts
import { makeStyles as makeStyles4 } from "@material-ui/core";
var useStyles4 = makeStyles4((theme) => ({
  timestamp: {
    color: theme.palette.ColorTextAlt,
    padding: theme.spacing(1)
  }
}));

// src/components/divider/NxChatMessageDivider.tsx
function NxChatMessageDivider({
  timestamp
}) {
  const theme = useTheme3();
  const styles = useStyles4();
  return /* @__PURE__ */ React5.createElement(Box5, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "relative",
    px: 3,
    textAlign: "center"
  }, /* @__PURE__ */ React5.createElement(Box5, {
    borderColor: theme.palette.BorderMedium,
    borderTop: 1,
    flex: 1,
    mt: theme.spacing(0.3)
  }, "\xA0"), /* @__PURE__ */ React5.createElement(NxTypography4, {
    className: styles.timestamp,
    variant: "body5"
  }, formatTimestampLong(timestamp)), /* @__PURE__ */ React5.createElement(Box5, {
    borderColor: theme.palette.BorderMedium,
    borderTop: 1,
    flex: 1,
    mt: theme.spacing(0.3)
  }, "\xA0"));
}

// src/components/content/NxChatContent.tsx
import React11, { useEffect as useEffect3, useRef as useRef2 } from "react";
import { Box as Box11 } from "@material-ui/core";
import { Virtuoso } from "react-virtuoso";

// src/NxChatBar.tsx
import React8, { useEffect as useEffect2, useState as useState4, memo } from "react";
import { Box as Box8, IconButton, makeStyles as makeStyles6, useTheme as useTheme5 } from "@material-ui/core";
import { EditorState as EditorState3, ContentState } from "draft-js";
import {
  NxIconButton as NxIconButton2,
  NxTooltip as NxTooltip2,
  NxTypography as NxTypography6,
  addEmoji
} from "@playvs-inc/nexus-components";
import { Attach, Close, Send } from "@playvs-inc/nexus-icons";
import punycode from "punycode/";

// src/NxChatEmotes.tsx
import React6, { useState as useState3 } from "react";
import { Box as Box6, makeStyles as makeStyles5, Menu, MenuItem, useTheme as useTheme4 } from "@material-ui/core";
import {
  NxIconButton,
  NxTypography as NxTypography5,
  emotesMap
} from "@playvs-inc/nexus-components";
import { Emote } from "@playvs-inc/nexus-icons";
var useStyles5 = makeStyles5((theme) => ({
  menu: {
    width: 336,
    borderRadius: theme.mixins.cornerRadius["border-radius-10"]
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
    gridGap: theme.spacing(1)
  },
  item: {
    padding: theme.spacing(1),
    borderRadius: theme.mixins.cornerRadius["border-radius-4"],
    "&:hover, &:active, &:focus": {
      background: theme.palette.ColorBackgroundAlt2
    }
  },
  emote: {
    width: 32,
    height: 32
  },
  disabledButton: {
    "&:disabled": {
      backgroundColor: "transparent"
    }
  }
}));
function NxChatEmotes({
  onClick,
  stateIsClosed,
  setAnchorEl,
  anchorEl
}) {
  var _a;
  const theme = useTheme4();
  const styles = useStyles5();
  const [selectedEmote, setSelectedEmote] = useState3();
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(void 0);
  };
  const handleClick = (emote) => {
    onClick == null ? void 0 : onClick(emote);
    setAnchorEl(void 0);
  };
  const handleMouseEnter = (emote) => {
    setSelectedEmote(emotesMap[emote]);
  };
  const handleMouseLeave = () => {
    setSelectedEmote(void 0);
  };
  const emotes = Object.values(emotesMap);
  const emoteItems = emotes.map(({ name, src, prettyName }) => /* @__PURE__ */ React6.createElement(MenuItem, {
    key: `emote-${name}`,
    classes: { root: styles.item },
    "data-emote": name,
    dense: true,
    disableGutters: true,
    onClick: () => handleClick(name),
    onMouseEnter: () => handleMouseEnter(name),
    onMouseLeave: handleMouseLeave
  }, /* @__PURE__ */ React6.createElement("img", {
    alt: prettyName,
    className: styles.emote,
    src
  })));
  const emotePreview = selectedEmote && /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement("img", {
    alt: selectedEmote.prettyName,
    height: 40,
    src: (_a = selectedEmote.altSrc) != null ? _a : selectedEmote.src,
    width: 40
  }), /* @__PURE__ */ React6.createElement(Box6, null, /* @__PURE__ */ React6.createElement(NxTypography5, {
    variant: "button"
  }, selectedEmote.prettyName), /* @__PURE__ */ React6.createElement(NxTypography5, {
    variant: "body4"
  }, ":", selectedEmote.name, ":")));
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(NxIconButton, {
    className: styles.disabledButton,
    disabled: stateIsClosed,
    icon: /* @__PURE__ */ React6.createElement(Emote, {
      "data-cy": "preview-emotes"
    }),
    onClick: handleOpen,
    p: 4,
    variant: "text"
  }), /* @__PURE__ */ React6.createElement(Menu, {
    anchorEl,
    classes: { paper: styles.menu },
    elevation: 2,
    keepMounted: true,
    onClose: handleClose,
    open: Boolean(anchorEl)
  }, /* @__PURE__ */ React6.createElement(Box6, {
    p: 4,
    pb: 1
  }, /* @__PURE__ */ React6.createElement(NxTypography5, {
    variant: "overline"
  }, "PlayVS Emotes"), /* @__PURE__ */ React6.createElement(Box6, {
    className: styles.list,
    mt: 1
  }, emoteItems)), /* @__PURE__ */ React6.createElement(Box6, {
    alignItems: "center",
    borderTop: `1px solid ${theme.palette.BorderLight}`,
    display: "flex",
    gridGap: theme.spacing(2),
    height: 72,
    p: 4
  }, emotePreview)));
}

// src/NxChatEditor.tsx
import React7, { useEffect, useRef } from "react";
import { Box as Box7 } from "@material-ui/core";
import { getDefaultKeyBinding } from "draft-js";
import DraftjsEditor from "@draft-js-plugins/editor";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import { createEmotePlugin } from "@playvs-inc/nexus-components";

// src/plugins/newlines/createNewlinePlugin.tsx
import { RichUtils, Modifier, EditorState } from "draft-js";

// src/plugins/newlines/utils/isSoftNewlineEvent.tsx
function isSoftNewlineEvent(evnt) {
  return evnt.key === "Enter" && (evnt.getModifierState("Shift") || evnt.getModifierState("Alt") || evnt.getModifierState("Control") || evnt.getModifierState("Meta"));
}

// src/plugins/newlines/createNewlinePlugin.tsx
var createNewlinePlugin_default = (options) => ({
  handleReturn: (event, editorState) => {
    var _a, _b;
    if (isSoftNewlineEvent(event)) {
      const selection = editorState.getSelection();
      if (selection.isCollapsed()) {
        (_a = options == null ? void 0 : options.onChange) == null ? void 0 : _a.call(options, RichUtils.insertSoftNewline(editorState));
      } else {
        const content = editorState.getCurrentContent();
        let newContent = Modifier.removeRange(content, selection, "forward");
        const newSelection = newContent.getSelectionAfter();
        const block = newContent.getBlockForKey(newSelection.getStartKey());
        newContent = Modifier.insertText(newContent, newSelection, "\n", block.getInlineStyleAt(newSelection.getStartOffset()), void 0);
        (_b = options == null ? void 0 : options.onChange) == null ? void 0 : _b.call(options, EditorState.push(editorState, newContent, "insert-fragment"));
      }
      return "handled";
    }
    return "not-handled";
  }
});

// src/plugins/newlines/index.ts
var newlines_default = createNewlinePlugin_default;

// src/NxChatEditor.tsx
var emotePlugin = createEmotePlugin();
var linkPlugin = createLinkifyPlugin({
  theme: {
    link: "chatLink"
  }
});
function NxChatEditor({
  editorState,
  onSubmit,
  stateIsClosed,
  setEditorState
}) {
  const handleChange = React7.useCallback((newEditorState) => {
    setEditorState(newEditorState);
  }, [setEditorState]);
  const editorRef = useRef();
  const newlinePlugin = newlines_default({ onChange: handleChange });
  const plugins = [emotePlugin, newlinePlugin, linkPlugin];
  const submitKeybindingFn = (evt) => {
    try {
      if (evt.key === "Enter" && !isSoftNewlineEvent(evt)) {
        onSubmit == null ? void 0 : onSubmit();
        return "nexus-submit";
      }
    } catch (e) {
    }
    return getDefaultKeyBinding(evt);
  };
  useEffect(() => {
    editorRef.current.focus();
  }, []);
  return /* @__PURE__ */ React7.createElement(Box7, {
    flex: 1
  }, /* @__PURE__ */ React7.createElement(DraftjsEditor, {
    ref: editorRef,
    editorState,
    keyBindingFn: submitKeybindingFn,
    onChange: handleChange,
    placeholder: "Write a message",
    plugins,
    readOnly: stateIsClosed
  }));
}
var NxChatEditor_default = NxChatEditor;

// src/NxChatBar.tsx
var NxChatEmotesMemo = memo(NxChatEmotes);
var NxIconButtonMemo = memo(NxIconButton2);
var maxMessageLengths = {
  ["player" /* Player */]: 280,
  ["captain" /* Captain */]: 280,
  ["coach" /* Coach */]: 280,
  ["adim" /* Admin */]: 1e3
};
var useStyles6 = makeStyles6((theme) => ({
  charCount: {
    color: theme.palette.common.white,
    padding: theme.spacing(0.5)
  },
  media: {
    borderRadius: theme.shape.borderRadius * 2.5,
    height: 100,
    width: 100
  },
  mediaWrapper: {
    padding: "10px 10px 0px 0px"
  },
  removeButton: {
    top: 0,
    right: 0,
    position: "absolute",
    backgroundColor: theme.palette.ColorBackgroundAlt2,
    padding: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.ColorIconDisabled
    }
  },
  disabledButton: {
    "&:disabled": {
      backgroundColor: "transparent"
    }
  },
  formWrapper: {
    transition: ({
      visibility
    }) => visibility === "hidden" ? "visibility 0.5s linear" : "opacity 0.5s linear",
    opacity: ({
      visibility
    }) => visibility === "visible" ? 1 : 0
  }
}));
function NxChatBar({
  isSendDisabled = false,
  isAttachDisabled = false,
  error,
  onSend,
  media = [],
  onClickAttach,
  onClickRemove,
  onClickEmote,
  visibility = "visible",
  chatRole = "player" /* Player */,
  stateIsClosed,
  global
}) {
  const theme = useTheme5();
  const styles = useStyles6({ visibility });
  const [anchorElEmoji, setAnchorElEmoji] = useState4();
  const [tooltipIsShown, setTooltipIsShown] = useState4(false);
  const [editorState, setEditorState] = useState4(() => EditorState3.createEmpty());
  const [currentCount, setCurrentCount] = useState4(0);
  const renderedIsSendDisabled = isSendDisabled || currentCount === 0;
  const limit = maxMessageLengths[chatRole];
  const showImageAttachment = chatRole === "adim" /* Admin */ || chatRole === "coach" /* Coach */;
  const handleSubmit = (evt) => {
    evt == null ? void 0 : evt.preventDefault();
    if (!renderedIsSendDisabled) {
      const raw = getPlainText(editorState);
      onSend(raw);
      const newEditorState = EditorState3.push(editorState, ContentState.createFromText(""), "delete-character");
      setEditorState(EditorState3.moveFocusToEnd(newEditorState));
    } else if (!tooltipIsShown) {
      setTooltipIsShown(true);
      setTimeout(() => {
        setTooltipIsShown(false);
      }, 1e3 * 3);
    }
  };
  const handleClickEmote = React8.useCallback((emote) => {
    const newEditorState = addEmoji(editorState, emote);
    setEditorState(newEditorState);
    onClickEmote == null ? void 0 : onClickEmote(emote);
  }, [onClickEmote, editorState]);
  const handleRemoveMedia = (data, ndx) => {
    onClickRemove == null ? void 0 : onClickRemove(data, ndx);
  };
  const attachments = Boolean(media == null ? void 0 : media.length) && /* @__PURE__ */ React8.createElement(Box8, {
    className: styles.formWrapper,
    display: "flex",
    gridGap: theme.spacing(1),
    overflow: "auto",
    pt: 3,
    px: 3
  }, media.map((data, ndx) => /* @__PURE__ */ React8.createElement(Box8, {
    key: `${data.sid}`,
    className: styles.mediaWrapper,
    position: "relative"
  }, /* @__PURE__ */ React8.createElement(IconButton, {
    className: styles.removeButton,
    onClick: () => handleRemoveMedia(data, ndx)
  }, /* @__PURE__ */ React8.createElement(Close, null)), /* @__PURE__ */ React8.createElement(NxChatImage, {
    className: styles.media,
    media: data
  }))));
  useEffect2(() => {
    function getCharCount(es) {
      const decodeUnicode = (str) => punycode.ucs2.decode(str);
      const plainText = getPlainText(es);
      const regex = /(?:\r\n|\r|\n)/g;
      const cleanString = plainText.replace(regex, "").trim();
      const newCount = decodeUnicode(cleanString).length;
      setCurrentCount(newCount);
    }
    getCharCount(editorState);
  }, [editorState.getCurrentContent()]);
  const amountOverLimit = currentCount > limit ? limit - currentCount : 0;
  const showCharOverLimit = Boolean(amountOverLimit);
  const isEmojiMenuOpen = Boolean(anchorElEmoji);
  return /* @__PURE__ */ React8.createElement("form", {
    className: styles.formWrapper,
    onSubmit: handleSubmit
  }, /* @__PURE__ */ React8.createElement(Box8, {
    borderTop: `1px solid ${theme.palette.BorderLight}`
  }, attachments, /* @__PURE__ */ React8.createElement(Box8, {
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.BorderLight}`,
    display: "flex",
    gridGap: 0.5
  }, /* @__PURE__ */ React8.createElement(NxChatEditor_default, {
    editorState,
    onSubmit: handleSubmit,
    setEditorState,
    stateIsClosed
  }), showCharOverLimit ? /* @__PURE__ */ React8.createElement(Box8, {
    bgcolor: theme.palette.ColorIconError,
    borderRadius: theme.mixins.cornerRadius["border-radius-4"],
    maxWidth: "fit-content"
  }, /* @__PURE__ */ React8.createElement(NxTypography6, {
    className: styles.charCount,
    variant: global ? "body4" : "body1"
  }, amountOverLimit)) : null, /* @__PURE__ */ React8.createElement(Box8, {
    px: 3
  }, error ? /* @__PURE__ */ React8.createElement(NxTooltip2, {
    arrow: true,
    color: "ColorTextAlt2",
    open: tooltipIsShown,
    placement: "top-start",
    title: error
  }, /* @__PURE__ */ React8.createElement("span", null, /* @__PURE__ */ React8.createElement(NxIconButton2, {
    className: styles.disabledButton,
    disabled: stateIsClosed,
    icon: /* @__PURE__ */ React8.createElement(Send, {
      color: renderedIsSendDisabled ? theme.palette.ColorIconDisabled : ""
    }),
    id: "match-chat-send-message",
    onMouseEnter: () => setTooltipIsShown(true),
    onMouseLeave: () => setTooltipIsShown(false),
    p: 4,
    type: "submit",
    variant: "text"
  }))) : /* @__PURE__ */ React8.createElement(NxIconButton2, {
    className: styles.disabledButton,
    disabled: stateIsClosed,
    icon: /* @__PURE__ */ React8.createElement(Send, {
      color: renderedIsSendDisabled ? theme.palette.ColorIconDisabled : ""
    }),
    id: "match-chat-send-message",
    onMouseEnter: () => setTooltipIsShown(true),
    onMouseLeave: () => setTooltipIsShown(false),
    p: 4,
    type: "submit",
    variant: "text"
  }))), /* @__PURE__ */ React8.createElement(Box8, {
    alignItems: "center",
    display: "flex",
    gridGap: theme.spacing(2),
    px: 3,
    py: 2
  }, onClickAttach && showImageAttachment && /* @__PURE__ */ React8.createElement(NxIconButtonMemo, {
    className: styles.disabledButton,
    disabled: isAttachDisabled || stateIsClosed,
    icon: /* @__PURE__ */ React8.createElement(Attach, null),
    onClick: onClickAttach,
    p: 4,
    variant: "text"
  }), onClickEmote && /* @__PURE__ */ React8.createElement(NxChatEmotesMemo, {
    anchorEl: anchorElEmoji,
    onClick: isEmojiMenuOpen ? handleClickEmote : void 0,
    setAnchorEl: setAnchorElEmoji,
    stateIsClosed
  }))));
}

// src/components/message/NxChatMessageWrapper.tsx
import React9 from "react";
import { Box as Box9 } from "@material-ui/core";
function NxChatMessageWrapper({
  data,
  previousData,
  global
}) {
  let newDay = true;
  if (previousData) {
    newDay = !areTimestampsSameDay(data.timestamp, previousData.timestamp);
  }
  const shouldShowDetails = newDay || (previousData == null ? void 0 : previousData.author.id) !== data.author.id;
  return /* @__PURE__ */ React9.createElement(Box9, {
    key: `box-${data.messageId}`
  }, newDay && /* @__PURE__ */ React9.createElement(NxChatMessageDivider, {
    timestamp: data.timestamp
  }), /* @__PURE__ */ React9.createElement(NxChatMessage, __spreadProps(__spreadValues({}, data), {
    global,
    showDetails: shouldShowDetails
  })));
}

// src/components/content/NxChatContent.styles.ts
import { makeStyles as makeStyles7 } from "@material-ui/core";
var useStyles7 = makeStyles7((theme) => ({
  transitionWrapper: {
    transition: "opacity 0.3s linear",
    opacity: ({
      visibility
    }) => visibility === "visible" ? 1 : 0
  },
  archivedMessages: {
    textAlign: "center",
    color: theme.palette.ColorTextLink
  }
}));
var globalUseStyles = makeStyles7((theme) => ({
  "@global": {
    ".DraftEditor-root": __spreadProps(__spreadValues({}, theme.typography.body1), {
      overflowX: "hidden",
      maxHeight: "15em",
      overflow: "auto",
      padding: theme.spacing(2, 3),
      border: 0,
      background: "none",
      fontFamily: '"TT Commons", Whitney, sans-serif',
      fontSize: "1em",
      color: theme.palette.ColorTextBase,
      resize: "none",
      "&> .public-DraftEditorPlaceholder-root": {
        fontFamily: '"TT Commons", Whitney, sans-serif',
        color: theme.palette.ColorTextDisabled,
        fontSize: "1em",
        width: "auto",
        position: "absolute",
        pointerEvents: "none"
      }
    }),
    ".public-DraftStyleDefault-block": {
      wordBreak: "break-all"
    },
    ".public-DraftStyleDefault-block > *": {
      verticalAlign: "bottom"
    },
    ".public-DraftEditorPlaceholder-root": {
      width: "auto"
    },
    ".chatLink": {
      color: theme.palette.ColorTextLink,
      "&:hover, &:active": {
        color: theme.palette.ColorTextLinkHover
      }
    }
  }
}));

// src/components/content/NxLoadOlderMessages.tsx
import React10 from "react";
import { Box as Box10 } from "@material-ui/core";
import { NxTextLink } from "@playvs-inc/nexus-components";
function NxLoadOlderMessages({
  hasOlderMessages,
  onLoadMessages,
  visibility = "visible"
}) {
  const styles = useStyles7({ visibility });
  return hasOlderMessages && onLoadMessages ? /* @__PURE__ */ React10.createElement(Box10, {
    display: "flex",
    justifyContent: "center"
  }, /* @__PURE__ */ React10.createElement(NxTextLink, {
    className: styles.archivedMessages,
    label: "Load older messages",
    labelVariant: "body3",
    onClick: onLoadMessages
  })) : /* @__PURE__ */ React10.createElement("div", null);
}

// src/components/content/NxChatContent.tsx
function getItemContent(index, data, global) {
  return /* @__PURE__ */ React11.createElement(Box11, {
    pb: index === data.length - 1 ? 2 : 0
  }, /* @__PURE__ */ React11.createElement(NxChatMessageWrapper, {
    data: data[index],
    global,
    previousData: data[index - 1]
  }));
}
var NxChatContent = React11.forwardRef(({
  data = [],
  hasOlderMessages,
  onLoadMessages,
  onSend,
  onClickAttach,
  onClickRemove,
  onClickEmote,
  value,
  error,
  media,
  isLoading,
  isSendDisabled = false,
  isAttachDisabled = false,
  global = false,
  visibility = "visible",
  stateIsClosed,
  loadingConversationState,
  chatRole = "player" /* Player */
}, ref) => {
  const styles = useStyles7({ visibility });
  const scrollRef = useRef2(null);
  globalUseStyles();
  const handleSend = (val) => {
    onSend(val);
  };
  useEffect3(() => {
    var _a;
    (_a = scrollRef.current) == null ? void 0 : _a.scrollToIndex(data.length - 1);
  }, [data.length]);
  const messagesContainer = /* @__PURE__ */ React11.createElement(Box11, {
    ref,
    className: styles.transitionWrapper,
    flex: 1,
    overflow: "auto",
    visibility
  }, /* @__PURE__ */ React11.createElement(Virtuoso, {
    ref: scrollRef,
    components: {
      Header: () => /* @__PURE__ */ React11.createElement(NxLoadOlderMessages, {
        hasOlderMessages,
        onLoadMessages,
        visibility
      })
    },
    followOutput: "smooth",
    initialTopMostItemIndex: data.length - 1,
    itemContent: (index) => getItemContent(index, data, global),
    totalCount: data.length
  }));
  return /* @__PURE__ */ React11.createElement(React11.Fragment, null, data.length ? messagesContainer : /* @__PURE__ */ React11.createElement(NxChatEmptyState, {
    isLoading,
    loadingConversationState,
    stateIsClosed,
    visibility
  }), /* @__PURE__ */ React11.createElement(NxChatBar, {
    chatRole,
    error,
    global,
    isAttachDisabled,
    isLoading,
    isSendDisabled,
    media,
    onClickAttach,
    onClickEmote,
    onClickRemove,
    onSend: handleSend,
    stateIsClosed,
    value,
    visibility
  }));
});

// src/NxChat.tsx
var useStyles8 = makeStyles8((theme) => ({
  chat: ({ maxWidth }) => ({
    background: theme.palette.ColorBackgroundBase,
    height: 500,
    maxWidth,
    borderBottomRightRadius: theme.shape.borderRadius * 2.5,
    borderBottomLeftRadius: theme.shape.borderRadius * 2.5,
    boxShadow: theme.mixins.boxShadow.elevation1
  }),
  emptyText: {
    color: theme.palette.ColorTextDisabled
  },
  timestamp: {
    color: theme.palette.ColorTextAlt,
    padding: theme.spacing(1)
  },
  loadText: {
    textAlign: "center"
  }
}));
var NxChat = React12.forwardRef((_a, ref) => {
  var _b = _a, {
    maxWidth,
    global = false,
    stateIsClosed,
    loadingConversationState
  } = _b, rest = __objRest(_b, [
    "maxWidth",
    "global",
    "stateIsClosed",
    "loadingConversationState"
  ]);
  const styles = useStyles8({ maxWidth });
  return /* @__PURE__ */ React12.createElement(Box12, {
    className: styles.chat,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    pt: global ? 0 : 3
  }, /* @__PURE__ */ React12.createElement(NxChatContent, __spreadValues({
    ref,
    global,
    loadingConversationState,
    stateIsClosed
  }, rest)));
});

// src/global/NxGlobalChat.tsx
import React13 from "react";
import { Box as Box13, makeStyles as makeStyles9, useTheme as useTheme7, IconButton as IconButton2 } from "@material-ui/core";
import { NxRandomAvatar as NxRandomAvatar2 } from "@playvs-inc/nexus-random-avatars";
import {
  NxTypography as NxTypography7,
  NxEsportAvatar,
  NxDropdownButton
} from "@playvs-inc/nexus-components";
import { Close as Close2, Moremenu } from "@playvs-inc/nexus-icons";
import { clsx as clsx2 } from "clsx";
var usePulseStyles = makeStyles9((theme) => ({
  "@global": {
    "@keyframes color": {
      from: {
        backgroundColor: theme.palette.ColorBackgroundBase
      },
      to: {
        backgroundColor: theme.palette.ColorBackgroundBrand
      }
    }
  },
  pulse: {
    backgroundColor: theme.palette.ColorBackgroundBrand,
    animationName: "color",
    animationDuration: "2s",
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-out",
    borderTopLeftRadius: theme.shape.borderRadius * 2.5,
    borderTopRightRadius: theme.shape.borderRadius * 2.5
  }
}));
var useStyles9 = makeStyles9((theme) => ({
  chat: {
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    background: theme.palette.ColorBackgroundBase,
    boxShadow: theme.mixins.boxShadow.elevation1,
    width: "343px",
    borderTopLeftRadius: theme.shape.borderRadius * 2.5,
    borderTopRightRadius: theme.shape.borderRadius * 2.5,
    [theme.breakpoints.up("sm")]: {
      height: ({ expanded }) => expanded ? "447px" : "56px"
    }
  },
  header: {
    height: "56px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  pulse: {
    backgroundColor: theme.palette.ColorBackgroundBrand,
    animationName: "color",
    animationDuration: "2s",
    animationIterationCount: "infinite"
  },
  chatTitle: {
    color: theme.palette.ColorTextAlt2
  },
  teamTitle: {
    background: "inherit",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textTransform: "capitalize"
  },
  titleContainer: {
    maxWidth: "calc(100% - 150px)"
  },
  chatTitleWrapper: {
    transition: "opacity 0.3s linear",
    opacity: ({ expanded }) => expanded ? 1 : 0
  }
}));
var NxGlobalChat = React13.forwardRef((_a, ref) => {
  var _b = _a, {
    teamName = "",
    esportSlug,
    isCoachChat = false,
    onClose,
    global = true,
    triggerPulse = false,
    onExpanded,
    expanded = true,
    className,
    menuOptions
  } = _b, rest = __objRest(_b, [
    "teamName",
    "esportSlug",
    "isCoachChat",
    "onClose",
    "global",
    "triggerPulse",
    "onExpanded",
    "expanded",
    "className",
    "menuOptions"
  ]);
  const theme = useTheme7();
  const visibility = expanded ? "visible" : "hidden";
  const styles = useStyles9({ expanded });
  const pulseStyles = usePulseStyles();
  const renderMenu = Boolean(menuOptions == null ? void 0 : menuOptions.length);
  const avatar = esportSlug ? /* @__PURE__ */ React13.createElement(NxEsportAvatar, {
    esport: esportSlug,
    iconHeight: 18,
    iconWidth: 18
  }) : /* @__PURE__ */ React13.createElement(NxRandomAvatar2, {
    height: 32,
    persona: "Firebob",
    width: 32
  });
  return /* @__PURE__ */ React13.createElement(Box13, {
    className: clsx2(className, styles.chat),
    "data-cy": "globalChatWindow",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React13.createElement(Box13, {
    alignItems: "center",
    boxShadow: theme.mixins.boxShadow.elevation1,
    className: triggerPulse && !expanded ? clsx2(pulseStyles.pulse, styles.header) : styles.header,
    "data-cy": "globalChatHeader",
    display: "flex",
    onClick: onExpanded,
    pl: 2,
    pr: 1,
    py: 1
  }, avatar, /* @__PURE__ */ React13.createElement(Box13, {
    className: styles.titleContainer,
    display: "flex",
    flex: 1,
    pl: 1
  }, /* @__PURE__ */ React13.createElement(NxTypography7, {
    className: styles.teamTitle,
    "data-cy": teamName,
    variant: "body2"
  }, teamName)), /* @__PURE__ */ React13.createElement(Box13, {
    alignItems: "center",
    display: "flex",
    pl: theme.spacing(0.5)
  }, renderMenu && /* @__PURE__ */ React13.createElement(NxDropdownButton, {
    "data-cy": "chat-options-drop-down",
    icon: /* @__PURE__ */ React13.createElement(Moremenu, null),
    menuItems: menuOptions != null ? menuOptions : [],
    variant: "text"
  }), /* @__PURE__ */ React13.createElement(IconButton2, {
    onClick: (e) => {
      e.stopPropagation();
      onClose == null ? void 0 : onClose();
    }
  }, /* @__PURE__ */ React13.createElement(Close2, {
    "data-cy": "chat-close-button"
  })))), /* @__PURE__ */ React13.createElement(Box13, {
    alignItems: "center",
    bgcolor: theme.palette.ColorBackgroundAlt,
    display: "flex",
    justifyContent: "center",
    mb: 1,
    p: 1,
    visibility
  }, /* @__PURE__ */ React13.createElement(NxTypography7, {
    className: styles.chatTitle,
    "data-cy": isCoachChat ? "Coach-chat" : "All-chat",
    variant: "overline"
  }, isCoachChat ? "Coach" : "All", " Chat")), /* @__PURE__ */ React13.createElement(NxChatContent, __spreadProps(__spreadValues({
    global: true,
    visibility
  }, rest), {
    ref
  })));
});

// src/links/plugin/components/Link.tsx
import { makeStyles as makeStyles10 } from "@material-ui/core";
import { NxTextLink as NxTextLink2 } from "@playvs-inc/nexus-components";
import React14 from "react";
var useStyles10 = makeStyles10({
  link: {
    display: "inline-block",
    textTransform: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});
function Link({ href }) {
  const classes = useStyles10();
  return /* @__PURE__ */ React14.createElement(NxTextLink2, {
    className: classes.link,
    href,
    label: href,
    rel: "noopener",
    target: "_blank",
    variant: "body1"
  });
}
export {
  ChatRole,
  Link,
  NxChat,
  NxChatBar,
  NxChatMessage,
  NxGlobalChat,
  areTimestampsSameDay,
  formatTimestamp,
  formatTimestampLong,
  getPlainText,
  getRoleData,
  maxMessageLengths
};
//# sourceMappingURL=index.js.map